/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './TFPAContactsAccordion.metadata.json5';
import styles from './TFPAContactsAccordion.module.scss'
import { Avatar } from '@jutro/components';

const TFPAContactsAccordion = props => {
    const {
        onTabChangeObj
    } = props;

    // DE17531
    const formatDate = (dob) => {
        const { year, month, day } = dob;
        // Original date string
        const originalDate = `${year}/${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}`;

        // Parse the date string
        const dateParts = originalDate.split("/");
        const yy = parseInt(dateParts[0]); // Extract the year
        const mm = parseInt(dateParts[1]) + 1; // Month is zero-indexed, add 1
        const dd = parseInt(dateParts[2]);

        // Adjust year to last two digits
        const shortYear = yy % 100;

        // Format the date as "M/DD/YY"
        const formattedDate = `${mm}/${dd}/${String(shortYear).padStart(2, '0')}`;
 

       // `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
        return formattedDate
      };

    // DE17695
    const getContactRole = (role) =>{
        return role;
    }

    const generateOverrides = useCallback(() => {
        if (!_.isUndefined(onTabChangeObj)) {

            const overrides = onTabChangeObj.latestJobPolicyPeriod.contacts.map((item, index) => {
                return {
                    [`contactsValue${index}`]: {
                        content: <div>
                            <div className={styles.container}>
                                
                                    <div key={index} className={styles.row}>
                                    
                                        <div className={styles.column}>
                                        <Avatar className={styles.avatar}/><span className={styles.name}>{item.contact.displayName.toUpperCase()}</span>
                                        </div>
                                        <div className={styles.column}>
                                            <span className={styles.value}>{getContactRole(item.contactRole)}</span>
                                        </div>
                                        <div className={styles.column}>
                                            <span className={styles.label}>Date of Birth</span>
                                            <br />
                                            <span className={styles.value}>{!_.isUndefined(item.contact.dateOfBirth) ? formatDate(item.contact.dateOfBirth) : ""}</span>
                                            <br />
                                            <span className={styles.label}>Email</span>
                                            <br />                                            
                                            <span className={styles.value}>{item.contact.emailAddress1}</span>
                                        </div>
                                        <div className={styles.column}>
                                            <span className={styles.label}>Home Phone</span>
                                            <br />
                                            <span className={styles.value}>{item.contact.homeNumber}</span>
                                            <br />
                                            <span className={styles.label}>Address</span>
                                            <br />
                                            <span className={styles.value}>{item.contact.primaryAddress.displayName}</span>
                                        </div>
                                    </div>                       
                            </div>
                        </div>
                    },
                };
            });

            return Object.assign({}, ...overrides);
        }

    }, [onTabChangeObj]);

    // const contactTableDate = ({ data }) => {
    //     return (
    //       <table className="custom-table">
    //         <tbody>
    //           {data.map((row, index) => (
    //             <tr key={index}>
    //               <td>{row.name}</td>
    //               <td>{row.role}</td>
    //               <td>
    //                 {row.dob}
    //                 <br />
    //                 {row.email}
    //               </td>
    //               <td>
    //                 {row.phone}
    //                 <br />
    //                 {row.address}
    //               </td>
    //             </tr>
    //           ))}
    //         </tbody>
    //       </table>
    //     );
    //   };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        contactsSection:{
            data:_.get(onTabChangeObj,'latestJobPolicyPeriod.contacts')
        },
        ...generateOverrides()
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={onTabChangeObj}
            // onModelChange={updateWizardData}
            // onValueChange={writeValue}
            // showErrors={showErrors}
            // onValidationChange={setComponentValidation}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


TFPAContactsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    //authHeader: PropTypes.shape({}).isRequired,
};
export default TFPAContactsAccordion;
